type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'outline';
type ButtonSize = 'sm' | 'md' | 'lg';

const BASE =
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-display font-bold uppercase tracking-[0.08em] transition-[background-color,color,border-color,transform] duration-150 ease-cine active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-night disabled:pointer-events-none disabled:opacity-40';

const VARIANTS: Record<ButtonVariant, string> = {
  primary: 'bg-action text-white hover:bg-action-hover',
  secondary: 'bg-white/15 text-white hover:bg-white/25',
  ghost: 'text-mist hover:bg-white/10 hover:text-white',
  outline: 'border border-graphite text-white hover:border-white/40 hover:bg-white/5',
};

const SIZES: Record<ButtonSize, string> = {
  sm: 'h-9 px-3.5 text-[11px]',
  md: 'h-11 px-5 text-xs',
  lg: 'h-12 px-6 text-[13px] md:h-14 md:px-8 md:text-sm',
};

export function buttonClass(
  variant: ButtonVariant = 'primary',
  size: ButtonSize = 'md',
  extra = '',
): string {
  return `${BASE} ${VARIANTS[variant]} ${SIZES[size]} ${extra}`.trim();
}

export function fieldClass(hasError: boolean): string {
  return `block w-full rounded-md border bg-night px-3.5 py-2.5 text-sm text-white placeholder:text-mist/60 transition-[border-color,box-shadow] duration-150 ease-out focus:outline-none focus:ring-2 ${
    hasError
      ? 'border-alert/70 focus:border-alert focus:ring-alert/30'
      : 'border-graphite focus:border-white/50 focus:ring-white/15'
  }`;
}

export const pagePadding = 'px-5 md:px-10 lg:px-14';
